import './qrIndex.css';
import { useState, useEffect, useCallback } from 'react';
import {
  FaSortDown,
  FaPlus,
  FaExternalLinkAlt,
  FaSistrix,
  FaUsers,
  FaUserCheck,
  FaUserTimes,
  FaSearch,
  FaUserCog,
  FaTools,
} from 'react-icons/fa';
import Layout from '../../components/Layout';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import { Box } from '@mui/material';
import { customBaseUrl, httpDelete, httpPost, httpGet } from '../../store/http';
import GeneratedQr from './generatedQrModal';
import CreateMarketer from './CreateMarketer';
import AntDropdown from '../../components/CustomDropdown/AntDropdown';
import ManageMarketer from './manageMarketer';
import ExcelUpload from './excelUpload';
import { Button as AntButton, Tabs, DatePicker } from 'antd';
import GenQR from './genQR';
import ManageQR from './manageQr';
import { hideLoader, showLoader } from '../../utils/loader';
import Swal from 'sweetalert2';
import { NotificationManager } from 'react-notifications';
import moment from 'moment';
import UpdateMarketerModal from './UpdateMarketerModal';

import { getMarketersList } from '../../services/referral/marketerService';
import CustomerLookupModal from './CustomerLookupModal';
import ManualAssignModal from './ManualAssignModal';
import UnattributedQueueModal from './UnattributedQueueModal';

const { RangePicker } = DatePicker;

const Search = ({
  selected,
  handleExport,
  setOpenExcel,
  setSelected,
  setSearchText,
  searchText,
  fetchData,
  onOpenLookup,
  onOpenAssign,
  onOpenRepair,
  setFromDate,
  setToDate,
}) => {
  const [openGenerateModal, setOpenGenerateModal] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const options = ['Id', 'Email', 'Name', 'Support Code', 'Phone Number'];

  const handleGenerateModal = () => {
    setOpenGenerateModal(true);
  };

  const dropDownOptions = ["Create single user", "Upload excel sheet to create"];
  const handleDropdownAction = (item) => {
    if (item === "Create single user") handleGenerateModal();
    if (item === "Upload excel sheet to create") setOpenExcel(true);
  };

  return (
    <section>
      <div className="search-wrapper">
        <div className="container" style={{ gap: '12px', flexWrap: 'wrap', alignItems: 'center' }}>
          <div className="dropdown">
            <div
              className="dropdown-btn"
              onClick={() => setIsActive(!isActive)}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ color: '#94a3b8', fontSize: '12px' }}>Search by:</span>
                {selected === 'Search by.....' ? 'All' : selected}
              </div>
              <FaSortDown style={{ marginBottom: '4px' }} />
            </div>

            {isActive && (
              <div className="dropdown-content">
                {['All', ...options].map((option) => (
                  <div
                    key={option}
                    onClick={() => {
                      setSelected(option === 'All' ? 'Search by.....' : option);
                      setIsActive(false);
                    }}
                    className="dropdown-item"
                  >
                    {option}
                  </div>
                ))}
              </div>
            )}
          </div>

          <SearchAndFilter searchText={searchText} setSearchText={setSearchText} />

          <RangePicker
            size="large"
            format="YYYY-MM-DD"
            onChange={(dates, dateStrings) => {
              setFromDate(dateStrings ? dateStrings[0] : "");
              setToDate(dateStrings ? dateStrings[1] : "");
            }}
            style={{ borderRadius: "8px" }}
          />

          <div className="mechanics" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <AntButton
              type="default"
              icon={<FaSearch style={{ marginRight: 6 }} />}
              onClick={onOpenLookup}
              style={{ borderRadius: '8px' }}
            >
              Customer Lookup
            </AntButton>

            <AntButton
              type="default"
              icon={<FaUserCog style={{ marginRight: 6 }} />}
              onClick={onOpenAssign}
              style={{ borderRadius: '8px' }}
            >
              Attribute Customer
            </AntButton>

            <AntButton
              type="default"
              icon={<FaTools style={{ marginRight: 6 }} />}
              onClick={onOpenRepair}
              style={{ borderRadius: '8px' }}
            >
              Repair Queue
            </AntButton>

            <button className="btn-premium btn-export" onClick={handleExport}>
              <FaExternalLinkAlt />
              Export CSV
            </button>

            <AntDropdown handleDropdownAction={handleDropdownAction} dropDownOptions={dropDownOptions}>
              <button className="btn-premium btn-create">
                <FaPlus />
                Create Field Marketer
              </button>
            </AntDropdown>
          </div>
        </div>
      </div>
      {openGenerateModal && (
        <CreateMarketer
          modalState={openGenerateModal}
          modalCloseAction={() => setOpenGenerateModal(false)}
          refreshData={fetchData}
        />
      )}
    </section>
  );
};

const SearchAndFilter = ({ setSearchText, searchText }) => {
  return (
    <div className="search">
      <div className="searchInputs">
        <div className="searchIcon">
          <FaSistrix />
        </div>
        <input
          className="text"
          type="text"
          placeholder="Search marketers by name, email, phone or support code"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>
    </div>
  );
};

const QR = () => {
  const [selected, setSelected] = useState('Search by.....');
  const [state, setState] = useState([]);
  const [qrData, setQrData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [opengenQr, setOpenGenQr] = useState(false);
  const [showManageMarkert, setShowManageMarkert] = useState(false);
  const [showManageQR, setShowManageQR] = useState(false);
  const [showUpdateMarketerModal, setShowUpdateMarketerModal] = useState(false);
  const [openExcel, setOpenExcel] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [count, setCount] = useState('');
  const [selectedMarketer, setSelectedMarketer] = useState([]);
  const [marketers, setMarketers] = useState([]);
  const [activeTab, setActiveTab] = useState('referral'); // 'referral' or 'card'
  const [pagination, setPagination] = useState({
    current: 0,
    pageSize: 20,
    total: 0,
  });

  // Modals for Referral Service Enhancements
  const [showLookupModal, setShowLookupModal] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [showUnattributedModal, setShowUnattributedModal] = useState(false);

  const deActivateUser = async (email, toggle) => {
    showLoader();
    const response = await httpPost(
      toggle === 'activate'
        ? `${customBaseUrl.cardUrl}/cms/admin/marketers/activate/${email}`
        : `${customBaseUrl.cardUrl}/cms/admin/marketers/deactivate/${email}`,
      {}
    );
    hideLoader();
    const { status, message } = response || {};
    if (status === false || status === undefined) {
      return Swal.fire("error", message || "An error occurred");
    }
    Swal.fire('Success', message || 'Updated successfully', 'success');
    fetchData();
  };

  const handleChangeRowsPerPage = async (value) => {
    setPagination((prev) => ({ ...prev, current: 0, pageSize: value }));
  };

  const handleChangePage = async (newPage) => {
    setPagination((prev) => ({ ...prev, current: newPage }));
  };

  const handleDeleteUser = async (email) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.value) {
        showLoader();
        const res = await httpDelete(`${customBaseUrl.cardUrl}/cms/marketers/${email}`);
        hideLoader();
        if (res.status === true) {
          NotificationManager.success("User Deleted Successfully");
          fetchData();
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.message,
          });
        }
      }
    });
  };

  const regenerateMarketerPassword = async (email) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to regenerate the password for this marketer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, regenerate it!",
    }).then(async (result) => {
      if (result.value) {
        showLoader();
        const res = await httpPost(`${customBaseUrl.cardUrl}/cms/admin/marketers/reset-password/${email}`, {});
        hideLoader();
        if (res.status === true) {
          NotificationManager.success("Marketer password regenerated successfully!");
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.message,
          });
        }
      }
    });
  };

  const handleResendOtp = async (email) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to resend OTP to this marketer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, resend it!",
    }).then(async (result) => {
      if (result.value) {
        showLoader();
        const res = await httpPost(`${customBaseUrl.cardUrl}/cms/marketers/resend-otp/${email}`, {});
        hideLoader();
        if (res.status === true) {
          NotificationManager.success("OTP resent successfully!");
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.message,
          });
        }
      }
    });
  };

  const handleMarketerAction = (item, row) => {
    setSelectedMarketer(row);
    if (item === "View users onboard") setShowManageMarkert(true);
    if (item === "Lookup Customer") setShowLookupModal(true);
    if (item === "Deactivate User" || item === "Activate User")
      deActivateUser(row.marketerUserEmail, item === "Activate User" ? 'activate' : 'deactivate');
    if (item === "Delete User") handleDeleteUser(row.marketerUserEmail);
    if (item === "Regenerate Password") regenerateMarketerPassword(row.marketerUserEmail);
    if (item === "Update Marketer") setShowUpdateMarketerModal(true);
    if (item === "Resend OTP") handleResendOtp(row.marketerUserEmail);
  };

  const columns = [
    {
      field: 'fullName',
      headerName: 'NAME',
      headerClassName: 'super-app-theme--header',
      width: 200,
    },
    {
      field: 'phoneNumber',
      headerName: 'PHONE',
      headerClassName: 'super-app-theme--header',
      width: 170,
    },
    {
      field: 'marketerUserEmail',
      headerName: 'EMAIL',
      headerClassName: 'super-app-theme--header',
      width: 220,
    },
    {
      field: 'supportCode',
      headerName: 'SUPPORT CODE',
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => row?.supportCode ?? 'N/A',
      width: 140,
    },
    {
      field: 'customersOnboarded',
      headerName: 'ONBOARDED',
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => row?.customersOnboarded ?? row?.numberOfCardsAssigned ?? 0,
      width: 130,
    },
    {
      field: 'transactionCount',
      headerName: 'TX COUNT',
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => row?.transactionCount ?? 0,
      width: 120,
    },
    {
      field: 'totalTransactionAmount',
      headerName: 'TOTAL VOLUME',
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        row?.totalTransactionAmount != null
          ? `₦${Number(row.totalTransactionAmount).toLocaleString(undefined, { minimumFractionDigits: 2 })}`
          : '₦0.00',
      width: 160,
    },
    {
      field: 'active',
      headerName: 'USER STATUS',
      headerClassName: 'super-app-theme--header',
      width: 140,
      renderCell: ({ row }) => (
        <span className={`status-badge ${row.active ? 'status-active' : 'status-inactive'}`}>
          {row.active ? 'Active' : 'Inactive'}
        </span>
      ),
    },
    {
      field: 'dateCreated',
      headerName: 'DATE',
      headerClassName: 'super-app-theme--header',
      width: 160,
      renderCell: ({ row }) => (row?.dateCreated ? moment(row.dateCreated).format('DD/MM/YYYY') : 'N/A'),
    },
    {
      field: 'action',
      headerName: 'ACTION',
      headerClassName: 'super-app-theme--header',
      width: 160,
      renderCell: ({ row }) => (
        <AntDropdown
          dropDownOptions={[
            "View users onboard",
            "Lookup Customer",
            "Delete User",
            row?.active ? "Deactivate User" : "Activate User",
            "Regenerate Password",
            "Update Marketer",
            "Resend OTP",
          ]}
          handleDropdownAction={(item) => handleMarketerAction(item, row)}
          userId={row}
          isArrow
        />
      ),
    },
  ];

  const fetchData = useCallback(async () => {
    showLoader();
    try {
      if (activeTab === 'referral') {
        // Tab 1: Fetch from Referral Service (/api/v1/marketer/list)
        const params = {
          pageNo: pagination.current,
          pageSize: pagination.pageSize,
        };
        if (searchText) params.query = searchText;
        if (fromDate) params.from = fromDate;
        if (toDate) params.to = toDate;

        const res = await getMarketersList(params);
        const resData = res?.data?.data || res?.data || res;
        const rawList = resData?.marketers || resData?.content || (Array.isArray(resData) ? resData : []);
        const totalElements = resData?.totalElements ?? rawList.length;

        const formatted = rawList.map((item, index) => {
          const m = item.marketer || item;
          return {
            ...m,
            ...item,
            id: m.id || m.supportCode || `ref_mkt_${index}`,
            fullName: m.name || m.fullName || `${m.firstName || ''} ${m.lastName || ''}`.trim() || 'N/A',
            marketerUserEmail: m.email || m.marketerUserEmail || 'N/A',
            phoneNumber: m.phoneNumber || m.phone || 'N/A',
            supportCode: m.supportCode || m.code || 'N/A',
            customersOnboarded: item.customersOnboarded ?? item.onboardedCount ?? 0,
            corporateOnboarded: item.corporateOnboarded ?? 0,
            personalOnboarded: item.personalOnboarded ?? 0,
            transactionCount: item.transactionCount ?? 0,
            totalTransactionAmount: item.totalTransactionAmount ?? 0,
            numberOfCardsAssigned: item.customersOnboarded ?? item.onboardedCount ?? 0,
            numberOfQRCodeAssigned: item.numberOfQRCodeAssigned ?? item.qrCount ?? 0,
            active: m.active ?? m.enabled ?? true,
            dateCreated: m.createdAt || m.dateCreated,
            source: 'REFERRAL_SERVICE',
          };
        });

        setMarketers(formatted);
        setState(formatted);
        setPagination((prev) => ({
          ...prev,
          total: totalElements,
        }));
      } else {
        // Tab 2: Fetch from Card Service (/cms/admin/marketers/all)
        const cardRes = await httpGet(`${customBaseUrl.cardUrl}/cms/admin/marketers/all`);
        const cardData = cardRes?.data || cardRes?.body || (Array.isArray(cardRes) ? cardRes : []);

        let formatted = [];
        if (Array.isArray(cardData)) {
          formatted = cardData.map((item, index) => ({
            ...item,
            id: item.id || item.supportCode || `card_mkt_${index}`,
            fullName: item.fullName || item.name || `${item.firstName || ''} ${item.lastName || ''}`.trim() || 'N/A',
            marketerUserEmail: item.marketerUserEmail || item.email || 'N/A',
            phoneNumber: item.phoneNumber || item.phone || 'N/A',
            supportCode: item.supportCode || item.code || 'N/A',
            customersOnboarded: item.numberOfCardsAssigned ?? item.customersOnboarded ?? 0,
            transactionCount: item.transactionCount ?? 0,
            totalTransactionAmount: item.totalTransactionAmount ?? 0,
            active: item.active ?? true,
            dateCreated: item.dateCreated || item.createdAt,
            source: 'CARD_SERVICE',
          }));
        }

        setMarketers(formatted);
        setState(formatted);
        setPagination((prev) => ({
          ...prev,
          total: formatted.length,
        }));
      }
    } catch (err) {
      console.error('Error fetching marketers:', err);
    } finally {
      hideLoader();
    }
  }, [activeTab, pagination.current, pagination.pageSize, searchText, fromDate, toDate]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const modalCloseAction = () => {
    setOpenModal(false);
    setOpenGenQr(false);
  };

  const isMarketerMatch = (e) => {
    if (!searchText) return true;
    const searchStr = searchText.trim().toLowerCase();
    const cleanSearch = searchStr.replace(/[^0-9a-z]/g, '');
    const cleanPhone = (e.phoneNumber || '').toString().replace(/[^0-9]/g, '');

    if (selected === "Id") return e.id?.toString().includes(searchStr);
    if (selected === "Email") return e.marketerUserEmail?.toLowerCase().includes(searchStr);
    if (selected === "Name") return e.fullName?.toLowerCase().includes(searchStr);
    if (selected === "Support Code") return e.supportCode?.toLowerCase().includes(searchStr);
    if (selected === "Phone Number" || selected === "Phone") {
      return (
        e.phoneNumber?.toString().toLowerCase().includes(searchStr) ||
        (cleanPhone && cleanSearch && cleanPhone.includes(cleanSearch))
      );
    }

    return (
      e.id?.toString().includes(searchStr) ||
      e.marketerUserEmail?.toLowerCase().includes(searchStr) ||
      e.fullName?.toLowerCase().includes(searchStr) ||
      e.supportCode?.toLowerCase().includes(searchStr) ||
      e.phoneNumber?.toString().toLowerCase().includes(searchStr) ||
      (cleanPhone && cleanSearch && cleanPhone.includes(cleanSearch))
    );
  };

  const handleExport = () => {
    const filteredMarketers = marketers.filter(isMarketerMatch);

    if (filteredMarketers.length === 0) {
      return NotificationManager.warning("No data to export");
    }

    const headers = ["ID", "Name", "Email", "Phone", "Support Code", "Status", "Date Created"];
    const csvContent = [
      headers.join(","),
      ...filteredMarketers.map((m) =>
        [
          m.id,
          `"${m.fullName || ''}"`,
          `"${m.marketerUserEmail || ''}"`,
          m.phoneNumber,
          `"${m.supportCode || ''}"`,
          m.active ? "Active" : "Inactive",
          m.dateCreated,
        ].join(",")
      ),
    ].join("\n");

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `Marketers_Export_${moment().format('YYYYMMDD_HHmm')}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Layout>
      {!showManageQR ? (
        !showManageMarkert ? (
          <div className="App">
            <div>
              <Button
                size="medium"
                style={{ background: "#fff", fontSize: "10px", color: "#000", display: 'none' }}
                onClick={() => setShowManageQR(true)}
              >
                Manage QR code
              </Button>
              <Button
                onClick={() => {
                  setShowManageQR(false);
                }}
                size="medium"
                style={{ background: "#FF4B01", margin: "10px", fontSize: "10px", color: "#fff" }}
              >
                Manage Field Marketer
              </Button>
            </div>
            <div>
              <Search
                handleExport={handleExport}
                searchText={searchText}
                setSearchText={setSearchText}
                setShowManageMarkert={setShowManageMarkert}
                setOpenExcel={setOpenExcel}
                selected={selected}
                setSelected={setSelected}
                fetchData={fetchData}
                onOpenLookup={() => setShowLookupModal(true)}
                onOpenAssign={() => setShowAssignModal(true)}
                onOpenRepair={() => setShowUnattributedModal(true)}
                setFromDate={setFromDate}
                setToDate={setToDate}
              />

              <div style={{ marginTop: '16px', marginBottom: '16px' }}>
                <Tabs
                  activeKey={activeTab}
                  onChange={(key) => {
                    setActiveTab(key);
                    setPagination((prev) => ({ ...prev, current: 0 }));
                  }}
                  type="card"
                  items={[
                    {
                      key: 'referral',
                      label: 'Referral Service',
                    },
                    {
                      key: 'card',
                      label: 'Card Service',
                    },
                  ]}
                />
              </div>

              <div className="cards-container">
                <div className="premium-card">
                  <div className="card-icon icon-total">
                    <FaUsers />
                  </div>
                  <div className="card-content">
                    <p>Total Field Marketers</p>
                    <h2>{pagination.total || marketers?.length || 0}</h2>
                  </div>
                </div>

                <div className="premium-card">
                  <div className="card-icon icon-active">
                    <FaUserCheck />
                  </div>
                  <div className="card-content">
                    <p>Active Marketers</p>
                    <h2>{marketers?.filter((m) => m.active)?.length ?? 0}</h2>
                  </div>
                </div>

                <div className="premium-card">
                  <div className="card-icon icon-inactive">
                    <FaUserTimes />
                  </div>
                  <div className="card-content">
                    <p>Inactive Marketers</p>
                    <h2>{marketers?.filter((m) => !m.active)?.length ?? 0}</h2>
                  </div>
                </div>
              </div>
            </div>
            <Box
              sx={{
                width: '100%',
                mt: 4,
                '& .MuiDataGrid-root': {
                  border: 'none',
                  backgroundColor: 'white',
                  borderRadius: '16px',
                  boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
                  overflow: 'hidden',
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#f8fafc !important',
                    borderBottom: '1px solid #e2e8f0',
                  },
                  '& .super-app-theme--header': {
                    color: '#64748b !important',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    fontSize: '11px',
                    letterSpacing: '0.05em',
                  },
                  '& .MuiDataGrid-cell': {
                    borderBottom: '1px solid #f1f5f9',
                    fontSize: '14px',
                    color: '#1e293b',
                    display: 'flex',
                    alignItems: 'center',
                  },
                  '& .MuiDataGrid-row:hover': {
                    backgroundColor: '#f8fafc',
                  },
                  '& .MuiDataGrid-columnSeparator': {
                    display: 'none',
                  },
                  '& .MuiDataGrid-footerContainer': {
                    borderTop: '1px solid #e2e8f0',
                  },
                },
              }}
            >
              <div
                style={{
                  height: 650,
                  width: '100%',
                  background: '#fff',
                  borderRadius: '16px',
                }}
              >
                <DataGrid
                  rows={marketers.filter(isMarketerMatch)}
                  columns={columns}
                  rowHeight={125}
                  page={pagination.current}
                  pageSize={pagination.pageSize}
                  onPageSizeChange={(newPageSize) => handleChangeRowsPerPage(newPageSize)}
                  onPageChange={(newPage) => handleChangePage(newPage)}
                  rowsPerPageOptions={[5, 10, 20, 50, 100]}
                  pagination
                  rowCount={pagination.total || marketers.length || 0}
                  components={{ Toolbar: GridToolbar }}
                />
              </div>
            </Box>
          </div>
        ) : (
          <ManageMarketer selectedMarketer={selectedMarketer} setShowManageMarkert={setShowManageMarkert} />
        )
      ) : (
        <ManageQR setShowManageQR={setShowManageQR} />
      )}

      {openModal && <GeneratedQr modalState={openModal} modalCloseAction={modalCloseAction} qrValue={qrData} />}
      {opengenQr && <GenQR showModal={opengenQr} hideModal={modalCloseAction} count={count} setCount={setCount} />}
      {showUpdateMarketerModal && (
        <UpdateMarketerModal
          visible={showUpdateMarketerModal}
          onCancel={() => setShowUpdateMarketerModal(false)}
          onUpdate={() => {
            setShowUpdateMarketerModal(false);
            fetchData();
          }}
          marketerData={selectedMarketer}
          fetchData={fetchData}
        />
      )}

      {openExcel && <ExcelUpload showModal={openExcel} hideModal={setOpenExcel} />}

      {/* Field Marketer Referral Service Enhancements Modals */}
      {showLookupModal && (
        <CustomerLookupModal
          visible={showLookupModal}
          onClose={() => setShowLookupModal(false)}
          onRefresh={fetchData}
        />
      )}

      {showAssignModal && (
        <ManualAssignModal
          visible={showAssignModal}
          onClose={() => setShowAssignModal(false)}
          onSuccess={fetchData}
        />
      )}

      {showUnattributedModal && (
        <UnattributedQueueModal
          visible={showUnattributedModal}
          onClose={() => setShowUnattributedModal(false)}
        />
      )}
    </Layout>
  );
};

export default QR;
